import { z } from 'zod';

import { Locale } from 'src/environments/language.config';

interface TagSchema {
  children?: TagSchema[];
  depth: number;
  id: number;
  name: Record<string, string>;
  parents: string[];
  weight: number;
}

export const TagSchema: z.ZodType<TagSchema> = z.lazy(() =>
  z.object({
    children: z.array(TagSchema).optional(),
    depth: z.number(),
    id: z.number(),
    name: z
      .object({ en: z.string(), de: z.string() })
      .transform((data) => ({ [Locale.EN]: data.en, [Locale.DE]: data.de })),
    parents: z.string().array(),
    weight: z.number(),
  })
);

export type TagMenu = z.infer<typeof TagSchema>;
